export default __webpack_public_path__ + "static/media/Basketball_00.1ae48dc2.png";